export default __webpack_public_path__ + "static/media/info.9caf0e39.svg";